import api from './axios';

export async function fetchAnnouncementEvents(params = {}) {
  const { data } = await api.get('/announcement-events', { params });
  return data.items || [];
}

export async function fetchAnnouncementEventById(id) {
  const { data } = await api.get(`/announcement-events/${id}`);
  return data.item;
}

export async function createAnnouncementEvent(payload) {
  const { data } = await api.post('/announcement-events', payload);
  return data.item;
}

export async function updateAnnouncementEvent(id, payload) {
  const { data } = await api.patch(`/announcement-events/${id}`, payload);
  return data.item;
}

export async function deleteAnnouncementEvent(id) {
  await api.delete(`/announcement-events/${id}`);
  return id;
}

export async function uploadAnnouncementImage(file, type = 'inline', entityId = 'temp', onProgress) {
  const formData = new FormData();
  formData.append('image', file);
  formData.append('type', type);
  formData.append('entityId', entityId);
  const { data } = await api.post('/announcement-events/upload-image', formData, {
    onUploadProgress: onProgress
      ? (e) => {
          const percent = e.total ? Math.round((e.loaded * 100) / e.total) : 0;
          onProgress(percent);
        }
      : undefined,
  });
  return data;
}

export async function uploadAnnouncementDocument(file, onProgress) {
  const formData = new FormData();
  formData.append('document', file);
  const { data } = await api.post('/announcement-events/upload-document', formData, {
    onUploadProgress: onProgress
      ? (e) => {
          const percent = e.total ? Math.round((e.loaded * 100) / e.total) : 0;
          onProgress(percent);
        }
      : undefined,
  });
  return data;
}
